module.exports = __webpack_public_path__ + "img/map-icon-0.27ced279.png";